/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Driver_No_Available_OrdersInputs */

const vi_dashboard_driver_no_available_orders = /** @type {(inputs: Dashboard_Driver_No_Available_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có đơn nào đang chờ.`)
};

/**

* @param {Dashboard_Driver_No_Available_OrdersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_driver_no_available_orders = /** @type {((inputs?: Dashboard_Driver_No_Available_OrdersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Driver_No_Available_OrdersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_driver_no_available_orders(inputs)
});